(function () {
  'use strict';

  function slugify(text, index) {
    var slug = String(text || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

    return slug || 'article-section-' + (index + 1);
  }

  function buildTableOfContents(body) {
    var toc = document.querySelector('[data-np-article-toc]');
    var list = document.querySelector('[data-np-article-toc-list]');
    var toggle = document.querySelector('[data-np-article-toc-toggle]');
    var headings = body ? body.querySelectorAll('h2') : [];

    if (!toc || !list || !toggle || headings.length < 2) return;

    var usedIds = {};

    for (var index = 0; index < headings.length; index += 1) {
      var heading = headings[index];
      var label = heading.textContent.trim();
      if (!label) continue;

      var baseId = heading.id || slugify(label, index);
      var headingId = baseId;
      var suffix = 2;

      while (usedIds[headingId] || (document.getElementById(headingId) && document.getElementById(headingId) !== heading)) {
        headingId = baseId + '-' + suffix;
        suffix += 1;
      }

      usedIds[headingId] = true;
      heading.id = headingId;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + headingId;
      link.textContent = label;
      item.appendChild(link);
      list.appendChild(item);
    }

    if (!list.children.length) return;

    toc.hidden = false;

    toggle.addEventListener('click', function () {
      var open = toc.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    list.addEventListener('click', function (event) {
      if (event.target && event.target.tagName === 'A' && window.innerWidth < 750) {
        toc.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function placePromotion(body) {
    var promotion = document.querySelector('[data-np-article-promo]');
    if (!body || !promotion || promotion.getAttribute('data-positioned') === 'true') return;

    var children = Array.prototype.slice.call(body.children);
    var eligible = children.filter(function (element) {
      return /^(P|UL|OL|BLOCKQUOTE|H2|H3)$/.test(element.tagName);
    });

    if (eligible.length < 7) return;

    var preferredIndex = Math.max(3, Math.floor(eligible.length * 0.4));
    var target = null;

    for (var index = preferredIndex; index < eligible.length; index += 1) {
      if (/^(P|UL|OL|BLOCKQUOTE)$/.test(eligible[index].tagName)) {
        target = eligible[index];
        break;
      }
    }

    if (!target) target = eligible[preferredIndex];
    if (!target) return;

    body.insertBefore(promotion, target.nextSibling);
    promotion.setAttribute('data-positioned', 'true');
  }

  function initializeArticleTemplate() {
    var body = document.querySelector('[data-np-article-body]');
    if (!body) return;

    buildTableOfContents(body);
    placePromotion(body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeArticleTemplate);
  } else {
    initializeArticleTemplate();
  }
}());
